import type { StatusLabelStatus } from '../../../common/enums/statusLabelStatus';
import { translateKey } from '../../translate';
import { Badge } from './Badge/Badge';
import { StatusLabelIcon } from './StatusLabelIcon';

interface IStatusLabelProps {
    badge?: boolean;
    icon?: boolean;
    statusLabel: StatusLabelStatus | undefined;
}

export function StatusLabel(props: IStatusLabelProps) {
    let value = null;
    if (props.statusLabel) {
        const status = props.icon ? (
            <StatusLabelIcon
                small
                statusLabel={props.statusLabel}
            />
        ) : (
            translateKey(`StatusLabelEnum.${props.statusLabel}`)
        );
        if (props.badge) {
            value = <Badge>{status}</Badge>;
        } else {
            value = <>{status}</>;
        }
    }

    return value;
}
